<template>
<div class="chapter">
<div class="inner_page">
<p class="ded" id="toc"><b>Table of Contents</b></p>
<p class="center">___________________</p>
<p class="toc"><a href="#/Text/chap1">Chapter One</a></p>
<p class="toc"><a href="#/Text/chap2">Chapter Two</a></p>
<p class="toc"><a href="#/Text/chap3">Chapter Three</a></p>
<p class="toc"><a href="#/Text/chap4">Chapter Four</a></p>
<p class="toc"><span href="#/Text/chap5" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc"><span href="#/Text/chap6" title="Link target outside of Sample">Chapter Six</span></p>
<p class="toc"><span href="#/Text/chap7" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="toc"><span href="#/Text/chap8" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="toc"><span href="#/Text/chap9" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="toc"><span href="#/Text/chap10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="toc"><span href="#/Text/chap11" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="toc"><span href="#/Text/chap12" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="toc"><span href="#/Text/chap13" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="toc"><span href="#/Text/chap14" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="toc"><span href="#/Text/chap15" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="toc"><span href="#/Text/chap16" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="toc"><span href="#/Text/chap17" title="Link target outside of Sample">Chapter Seventeen</span></p>
<p class="toc"><span href="#/Text/chap18" title="Link target outside of Sample">Chapter Eighteen</span></p>
<p class="toc"><span href="#/Text/chap19" title="Link target outside of Sample">Chapter Nineteen</span></p>
<p class="toc"><span href="#/Text/chap20" title="Link target outside of Sample">Chapter Twenty</span></p>
<p class="toc"><span href="#/Text/chap21" title="Link target outside of Sample">Chapter Twenty-One</span></p>
<p class="toc"><span href="#/Text/chap22" title="Link target outside of Sample">Chapter Twenty-Two</span></p>
<p class="toc"><span href="#/Text/chap23" title="Link target outside of Sample">Chapter Twenty-Three</span></p>
<p class="toc"><span href="#/Text/chap24" title="Link target outside of Sample">Chapter Twenty-Four</span></p>
<p class="toc"><span href="#/Text/chap25" title="Link target outside of Sample">Chapter Twenty-Five</span></p>
<p class="toc"><span href="#/Text/chap26" title="Link target outside of Sample">Chapter Twenty-Six</span></p>
<p class="toc"><span href="#/Text/chap27" title="Link target outside of Sample">Chapter Twenty-Seven</span></p>
<p class="toc"><span href="#/Text/chap28" title="Link target outside of Sample">Chapter Twenty-Eight</span></p>
<p class="toc"><span href="#/Text/chap29" title="Link target outside of Sample">Chapter Twenty-Nine</span></p>
<p class="toc"><span href="#/Text/chap30" title="Link target outside of Sample">Chapter Thirty</span></p>
<p class="toc"><span href="#/Text/chap31" title="Link target outside of Sample">Chapter Thirty-One</span></p>
<p class="toc"><span href="#/Text/chap32" title="Link target outside of Sample">Chapter Thirty-Two</span></p>
<p class="toc"><span href="#/Text/chap33" title="Link target outside of Sample">Chapter Thirty-Three</span></p>
<p class="toc"><span href="#/Text/chap34" title="Link target outside of Sample">Chapter Thirty-Four</span></p>
<p class="toc"><span href="#/Text/chap35" title="Link target outside of Sample">Chapter Thirty-Five</span></p>
<p class="toc"><span href="#/Text/chap36" title="Link target outside of Sample">Chapter Thirty-Six</span></p>
<p class="toc"><span href="#/Text/extra" title="Link target outside of Sample">E-Book Extra: Excerpt from <i>Even in Paradise</i></span></p>
<p class="toc"><span href="#/Text/bio" title="Link target outside of Sample">About Elizabeth Nunez</span></p>
<p class="toc"><span href="#/Text/copy" title="Link target outside of Sample">Copyright &amp; Credits</span></p>
<p class="toc"><span href="#/Text/akb" title="Link target outside of Sample">About Akashic Books</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?38b526fb